import __var_0__ from '@stdlib/utils/constant-function';
import __var_1__ from '@stdlib/math/base/special/kernel-betaincinv';
import __var_2__ from '@stdlib/math/base/assert/is-nan';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var constantFunction = __var_0__;
var kernelBetaincinv = __var_1__;
var isnan = __var_2__;


// MAIN //

/**
* Returns a function for evaluating the quantile function for an F distribution with numerator degrees of freedom `d1` and denominator degrees of freedom `d2`.
*
* @param {PositiveNumber} d1 - numerator degrees of freedom
* @param {PositiveNumber} d2 - denominator degrees of freedom
* @returns {Function} quantile function
*
* @example
* var quantile = factory( 10.0, 2.0 );
* var y = quantile( 0.4 );
* // returns ~0.994
*
* y = quantile( 0.8 );
* // returns ~4.382
*/
function factory( d1, d2 ) {
	if (
		isnan( d1 ) ||
		isnan( d2 ) ||
		d1 <= 0.0 ||
		d2 <= 0.0
	) {
		return constantFunction( NaN );
	}
	return quantile;

	/**
	* Evaluates the quantile function for an F distribution.
	*
	* @private
	* @param {Probability} p - input value
	* @returns {number} evaluated quantile function
	*
	* @example
	* var y = quantile( 0.3 );
	* // returns <number>
	*/
	function quantile( p ) {
		var xs;
		if ( isnan( p ) || p < 0.0 || p > 1.0 ) {
			return NaN;
		}
		xs = kernelBetaincinv( d1/2.0, d2/2.0, p, 1.0 - p );
		return d2 * xs[ 0 ] / ( d1 * xs[ 1 ] );
	}
}


// EXPORTS //
export default factory;
